// Release Switch Toggles: should not be used directly
// @see getReleaseSwitchToggleCookieName util
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_SWITCH_TOGGLE_AT = 'release-switch-at'

// Release Toggles
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_CART_CTA_DELAYED = 'cart-cta-delayed'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'
export const RELEASE_TOGGLE_MP_CROSS_SELL = 'mp-cross-sell'
export const RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED = 'enabled'
export const RELEASE_TOGGLE_VARIANT_ATTRIBUTES = 'variant-attributes'
export const RELEASE_TOGGLE_HOME_ONE = 'home-one'
export const RELEASE_TOGGLE_HOME_ONE_CMS = 'h1-cms'
export const RELEASE_TOGGLE_HOME_ONE_CART = 'h1-cart'
export const ERX_ADYEN_TOGGLE = 'erx-adyen'
export const ERX_ADYEN_MP_TOGGLE = 'erx-adyen-mp'
export const ERX_NOW_TOGGLE = 'erx-now'
export const APPLE_PAY_TOGGLE = 'wstra-2462'
export const HOME_ONE_ACCOUNT = 'wsssh-2348'
export const WELCOME_PAGE_TOGGLE = 'wscr-2386'
export const HOME_ONE_SERP = 'home-one-serp'
export const NOW_PICKUP_TOGGLE = 'wstra-12290'

// Experiments
export const ODS_CLIENT_FLOW = 'ods-client-flow'
export const NEW_HEADER = 'header'
export const CSW_PRODUCT_TITLE = 'cro-780'
export const NEW_CDN = 'cro-1881'
export const SERP_NOW_PUSH = 'cro-121'
export const SERP_LOAD_MORE = 'cro-179'
export const VARIANT_ATTRIBUTES = 'variant-attributes'
export const TOP_DEALS_LABEL = 'cro-1073'
export const CHANGE_GTM_SCRIPT = 'cro-4910'
export const DISPLAYING_DELIVERY_DATES_FOR_OTC_AND_MP = 'cro-5912'

export const NOW_HOMEPAGE_GB_FUNCTIONALITY = 'wstra-5032'
export const NOW_SERP_GB_FUNCTIONALITY = 'wstra-5031'
export const NOW_CATEGORY_GB_FUNCTIONALITY = 'wstra-5033'
export const SHIPPING_DELAY_NOTIFICATION = 'wstra-6359'
export const EXPERIMENT_PASSKEY_FAKE_DOOR = 'wscnl-8009-passkey-fake-door'

export const HOME_ONE_RETURN_PAGE = 'pdtra-19'
export const CANCEL_ORDER_CONTRACT_LINK = 'itet-802'

export const ALGOLIA_SPLIT = 'alg'

export const TOTAAL_KORTING_AB_TEST = 'wscnl-5650'
// test different pricing strategies
export const DIRECT_CHANNEL = 'direct'

export const SHOW_CONTACT_INFORMATION = 'wscnl-7196'

export const DISCOUNT_EXPERIMENT_FR = 'cro-4200'

export const EVENTS_AMAZONIZATION = 'pdcil-723'

export const RATEPAY_BUYER_PORTAL = 'wstra-12561'

export const GET_CART_V4 = 'wsawa-7452'

export const CBP_EXPERIMENT_COM = 'itrt-236'
export const EXPERIMENT_NAME_REMOVE_BANNERS = 'itrt-340'
export const EXPERIMENT_NAME_HOME_ONE_CATEGORIES_RELEASE = 'mat-514'
